import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import request from 'src/utils/request'

const initialState = {
  isLoading: false,
  isSuccess: false,
  seanceData: [],
  typeSeanceData: [],
  salleData: [],
  error: '',
}

export const getSeancesList = createAsyncThunk(
  'seance/getSeancesList',
  async ({ ANNEE_UNIVERSITAIRE }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.teacher.token
      const res = await request(token).get(`/teachers/seance`, {
        params: { ANNEE_UNIVERSITAIRE },
      })
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const getSallesList = createAsyncThunk('seance/getSallesList', async (_, thunkAPI) => {
  try {
    const token = await thunkAPI.getState().auth.teacher.token
    const res = await request(token).get(`/teachers/salle`)
    const data = await res.data
    return data
  } catch (err) {
    toast.error(err.response.data)
    return thunkAPI.rejectWithValue(err.response.data)
  }
})

export const getTypeSeancesList = createAsyncThunk(
  'seance/getTypeSeancesList',
  async (_, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.teacher.token
      const res = await request(token).get(`/teachers/typeSeance`)
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const seanceSlice = createSlice({
  name: 'seance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSeancesList.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(getSeancesList.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          seanceData: action.payload,
          error: '',
        }
      })
      .addCase(getSeancesList.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
      .addCase(getTypeSeancesList.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(getTypeSeancesList.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          typeSeanceData: action.payload,
          error: '',
        }
      })
      .addCase(getTypeSeancesList.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
      .addCase(getSallesList.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(getSallesList.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          salleData: action.payload,
          error: '',
        }
      })
      .addCase(getSallesList.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
  },
})

export default seanceSlice.reducer
